<template>
  <div class="card shadow-lg rounded-3 py-3" style="border-radius:0; border:none">
    <div class="card-body p-1">
      <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700"><span
          style="color: #0092f7">OTP</span> CODE</h1>

      <form @submit.prevent="submit">
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <input type="text" class="form-control"
                     v-model="otp" id="floatingTextInput1" placeholder="Username"
                     required>
              <label for="floatingTextInput1">Otp Code</label>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button :disabled="loading" type="submit" class="btn">
            Submit
            <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </form>
      <div class="text-center mt-2">
        <button type="submit" @click="resendOtp" class="btn">
          Resend Otp
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "otpForm",
  data() {
    return {
      otp: '',
      loading: false,
    };
  },
  methods: {
    submit() {
      this.loading = true;
      let id = generateUUID()
      // Get email from Vuex before clearing
      const userInfo = this.$store.getters.getUserInfo;
      const userEmail = userInfo ? userInfo.email : null;

      return this.$store.dispatch('verifyOtp', {otp: this.otp, localid: id})
          .then((data) => {
            console.log("FULL verifyOtp response:", JSON.stringify(data, null, 2));

            let id = generateUUID()
            sessionStorage.setItem('session', id);
            this.$store.commit('removeUserInfo');

            // Store email for later use since OTP response is empty
            if (userEmail) {
              localStorage.setItem('user_email', userEmail);

              // Try to fetch user details by email to get companyApiKey
              return this.$store.dispatch('getUserDetailsByEmail', userEmail)
                .then((userData) => {
                  console.log("User data fetched:", userData);
                  localStorage.setItem('current_user', JSON.stringify(userData));
                  this.$store.dispatch('getAllUsers');
                  this.$router.push({name: 'TransactionManager'})
                })
                .catch(() => {
                  // Fallback if fetch fails
                  localStorage.setItem('current_user', JSON.stringify({
                    email: userEmail,
                    companyID: 1
                  }));
                  this.$router.push({name: 'TransactionManager'})
                });
            } else {
              localStorage.setItem('current_user', JSON.stringify({}));
              this.$router.push({name: 'TransactionManager'})
            }
          })
          .finally(() => this.loading = false);
    },
    resendOtp() {
      this.$store.commit('setLoadingState', true);
      const payload = this.$store.getters.getUserInfo;
      return this.$store.dispatch('login', payload)
          .then(()=> responses.showSuccess('OTP resent successfully'))
          .finally(() => this.$store.commit('setLoadingState', false));
    },
  },
};
</script>

<style scoped>
.btn, .btn:hover {
  background: linear-gradient(90deg, rgba(65, 105, 225, 1) 0%, rgba(30, 144, 255, 1) 100%);
  color: white;
  font-weight: 600;
  display: block;
  width: 100%;
  height: 45px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
  max-width: 95vw;
  margin-top: -3rem !important;
}

.show-password-checkbox {
  margin-bottom: 20px;
}
</style>
